import React from 'react';
import { StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { bonuses, offer } from '../data/offer';
export function Hero() {
  return <section className="bg-espresso px-5 pb-14 pt-10 text-center" data-id="element-117" data-mp="9k0fha3kwjqp">
      <Reveal data-id="element-118" data-mp="4lqj4w64bd3i">
        <p className="flex items-center justify-center gap-2.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-wood" data-id="element-119" data-mp="4lysie31809y">
          <span className="h-px w-6 shrink-0 bg-wood" aria-hidden="true" data-id="element-120" data-mp="128fnvds7g3t2" />
          Per gli insegnanti di musica della primaria
        </p>
        <h1 className="mt-5 font-display text-[42px] uppercase leading-[0.95] text-ivory" data-id="element-121" data-mp="x8jmlmaw6qh7">
          Organizza tutte le tue lezioni
          <span className="block text-wood" data-id="element-122" data-mp="ncq2nhuufupe">di flauto dolce con questo pack</span>
        </h1>
        <p className="mt-5 font-serif text-lg italic leading-relaxed text-sand" data-id="element-123" data-mp="3d1a4za4glt8j">
          Il sistema «Stampa &amp; Insegna» che trasforma la preparazione delle lezioni di flauto da{' '}
          <span className="text-wood" data-id="element-124" data-mp="3j8iv8twpu6s2">caotica</span> a <span className="text-ivory" data-id="element-125" data-mp="3j9u252lgjune">semplice</span>.
        </p>
      </Reveal>

      <Reveal delay={0.08} className="relative mt-10" data-id="element-126" data-mp="3o7vlzpqpjxzx">
        <span className="absolute -top-3.5 right-3 z-10 rounded-full bg-wood px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-espresso shadow-cta" data-id="element-127" data-mp="3o59e1ozwngh6">
          1 libro + {offer.bonusCount} bonus
        </span>
        <div className="rounded-3xl border border-espresso-line bg-espresso-2 p-2 shadow-frame" data-id="element-128" data-mp="30hhpnn13bczj">
          {offer.heroImage ? <img src={offer.heroImage} alt="Il pack Flauto Master: il libro e tutti i bonus" className="w-full rounded-2xl object-cover" data-id="element-129" data-mp="359javyg8ke1p" /> : <BundleMockup data-id="element-130" data-mp="2vjg5szvub9n0" />}
        </div>
      </Reveal>

      <Reveal delay={0.12} className="mt-9" data-id="element-131" data-mp="2hix0w1mo8jp2">
        <CtaButton data-id="element-132" data-mp="2hjymh01bcol1">Voglio il pack completo — {offer.price}</CtaButton>
        <div className="mt-4 flex flex-col items-center gap-1.5" data-id="element-133" data-mp="2ljpe15ynz8qm">
          <div className="flex gap-0.5" aria-label="Valutazione 5 stelle su 5" data-id="element-134" data-mp="s1rsopcm88ut">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-wood text-wood" aria-hidden="true" data-id="element-135" data-mp="najihr3gojgl" data-mpi={i} />)}
          </div>
          <p className="text-[13px] text-sand" data-id="element-136" data-mp="ici1dbpliu7r">Pagamento unico · Accesso immediato · PDF via email</p>
        </div>
      </Reveal>
    </section>;
}
function BundleMockup() {
  return <div role="img" aria-label="Il pack su schermo con le copertine dei 5 bonus in primo piano" className="overflow-hidden rounded-2xl bg-wood-deep px-3 pb-4 pt-5" data-id="element-137" data-mp="1b0dts484tzyq">
      <div className="mx-auto w-[86%]" data-id="element-138" data-mp="111eqz2a1syjn">
        <div className="rounded-lg bg-espresso p-1.5" data-id="element-139" data-mp="114kg2hiog0fd">
          <div className="flex aspect-[16/9] flex-col items-center justify-center rounded bg-espresso-3 px-3" data-id="element-140" data-mp="x0cs4mk1moi7">
            <span className="font-display text-2xl uppercase tracking-wide text-ivory" data-id="element-141" data-mp="3lui6mj3rolho">
              Flauto <span className="text-wood" data-id="element-142" data-mp="3hpsft8nytx3m">Master</span>
            </span>
            <span className="mt-2 rounded-sm bg-wood px-2.5 py-1 font-display text-xs uppercase text-espresso" data-id="element-143" data-mp="1xacfj35u5jt8">
              Guida del docente + 50 esercizi
            </span>
            <span className="mt-1.5 text-[9px] font-semibold uppercase tracking-[0.2em] text-sand" data-id="element-144" data-mp="26a96xcjm0wrz">
              PDF pronti da stampare
            </span>
          </div>
        </div>
        <div className="mx-auto h-3 w-14 bg-espresso-line" aria-hidden="true" data-id="element-145" data-mp="2fzsuuwm6jgtp" />
      </div>
      <div className="-mt-6 flex justify-center gap-1.5" data-id="element-146" data-mp="2g256yt59awyu">
        {bonuses.map(b => <img key={b.number} src={b.cover} alt="" className="aspect-[3/4] w-[18.5%] rounded-md border border-espresso-line object-cover shadow-soft" data-id="element-147" data-mp="2l100oq4ri5xq" />)}
      </div>
    </div>;
}